import { createSlice } from "@reduxjs/toolkit";
import { buscarTotalCadastro, buscarTotalComprovanteConsignatario, buscarTotalContaAuditoria, buscarTotalContaFinanceira, buscarTotalContabilidade } from "../../../services/painelGeralService";
import { resetAll } from "../../actions/actions";

export interface PainelGeralState {
  loading: boolean;
  list: any[];
}

const initialState: PainelGeralState = {
  loading: false,
  list: [],
};

export const painelGeralSlice = createSlice({
  name: "painelGeral",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    //resetar estados
    builder.addCase(resetAll, () => initialState);

    //listar Contas a pagar e receber financeiro
    builder.addCase(buscarTotalContaFinanceira.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTotalContaFinanceira.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTotalContaFinanceira.rejected, (state, action) => {
      state.loading = false;
    });

    //listar Contas a pagar e receber auditoria
    builder.addCase(buscarTotalContaAuditoria.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTotalContaAuditoria.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTotalContaAuditoria.rejected, (state, action) => {
      state.loading = false;
    });

    //listar Total de comprovantes pendentes dos consignatarios
    builder.addCase(buscarTotalComprovanteConsignatario.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTotalComprovanteConsignatario.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTotalComprovanteConsignatario.rejected, (state, action) => {
      state.loading = false;
    });

    //listar Total de impostos e anexos pendentes contabil
    builder.addCase(buscarTotalContabilidade.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTotalContabilidade.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTotalContabilidade.rejected, (state, action) => {
      state.loading = false;
    });

    //listar Total cadastros admin
    builder.addCase(buscarTotalCadastro.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(buscarTotalCadastro.fulfilled, (state, action) => {
      state.list = action.payload;
      state.loading = false;
    });
    builder.addCase(buscarTotalCadastro.rejected, (state, action) => {
      state.loading = false;
    });
  },
});

export const { } = painelGeralSlice.actions;

export default painelGeralSlice.reducer;
